import React from 'react';
import PropTypes from 'prop-types';
import CrossIcon from '../../images/inline/cross.inline.svg';
import '../../styles/components/modal.scss'; // Styles for the modal

const Modal = ({ isOpen, onClose, children }) => {
  return (
    <div className={`modal ${isOpen ? 'modal-open' : 'modal-closed'}`}>
      <div className="modal-content">
        <button className="modal-close-button flex self-end cursor-pointer" onClick={onClose}>
          <CrossIcon />
        </button>
        <div className="px-12 pt-8 mobileModal">{children}</div>
      </div>
    </div>
  );
};

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired
};

export default Modal;
